export default function Browser() {
    let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    let isOpera = userAgent.indexOf('Opera') > -1; //判断是否Opera浏览器
    let isIE = window.ActiveXObject || 'ActiveXObject' in window;
    let isEdge = userAgent.indexOf('Edge') > -1; //判断是否IE的Edge浏览器
    let isFirefox = userAgent.indexOf('Firefox') > -1; //判断是否Firefox浏览器
    let isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1; //判断是否Safari浏览器
    let isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 && !isEdge; //判断Chrome浏览器
    let isQax = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Qaxbrowser') > -1; // 判断奇安信浏览器

    if (isQax) {return 'Qaxbrowser';}
    if (isFirefox) {return 'Firefox';}
    if (isOpera) {return 'Opera';}
    if (isSafari) {return 'Safari';}
    if (isChrome) {return 'Chrome';}
    if (isEdge) {return 'Edge';}
    if (isIE) {return 'IE';}
}
